<h2 mat-dialog-title [class.danger-title]="isDangerAction">
  @if (isDangerAction) {
    <span class="color-danger">
      <app-icon name="ic_problem"/>
      {{ data.title }}
    </span>
  } @else {
    {{ data.title }}
  }
</h2>
<mat-dialog-content>
  <p>{{ data.body }}</p>
  @if (data.hint) {
    <p class="bold">{{ data.hint }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button class="button" mat-dialog-close>{{ data.cancelLabel ?? 'default.cancel' | translate }}</button>
  <button class="button"
          [class.primary-button]="!isDangerAction"
          [class.danger-button]="isDangerAction"
          [mat-dialog-close]="true">{{ data.confirmLabel }}</button>
</mat-dialog-actions>
